// Plain-calendar date arithmetic on 'YYYY-MM-DD' strings — integer maths
// only, no Date object, so no timezone can move a day (INV-8: the built site
// carries no timezone API at all; designlaw.test.ts scans for it).
//
// daysFromCivil / civilFromDays are Howard Hinnant's public-domain
// days-from-civil algorithm: proleptic Gregorian, day 0 = 1970-01-01.

export function daysFromCivil(y: number, m: number, d: number): number {
  const yy = m <= 2 ? y - 1 : y;
  const era = Math.floor(yy / 400);
  const yoe = yy - era * 400;
  const mp = (m + 9) % 12;
  const doy = Math.floor((153 * mp + 2) / 5) + d - 1;
  const doe = yoe * 365 + Math.floor(yoe / 4) - Math.floor(yoe / 100) + doy;
  return era * 146097 + doe - 719468;
}

export function civilFromDays(z: number): [number, number, number] {
  const zz = z + 719468;
  const era = Math.floor(zz / 146097);
  const doe = zz - era * 146097;
  const yoe = Math.floor((doe - Math.floor(doe / 1460) + Math.floor(doe / 36524) - Math.floor(doe / 146096)) / 365);
  const doy = doe - (365 * yoe + Math.floor(yoe / 4) - Math.floor(yoe / 100));
  const mp = Math.floor((5 * doy + 2) / 153);
  const d = doy - Math.floor((153 * mp + 2) / 5) + 1;
  const m = mp < 10 ? mp + 3 : mp - 9;
  return [yoe + era * 400 + (m <= 2 ? 1 : 0), m, d];
}

function parse(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number);
  return daysFromCivil(y, m, d);
}

const pad = (n: number, w = 2): string => String(n).padStart(w, '0');

/** 'YYYY-MM-DD' plus n days (n may be negative). */
export function addDaysIso(iso: string, n: number): string {
  const [y, m, d] = civilFromDays(parse(iso) + n);
  return `${pad(y, 4)}-${pad(m)}-${pad(d)}`;
}

/** Whole days from `from` to `to` (negative when `to` is earlier). */
export function daysBetweenIso(from: string, to: string): number {
  return parse(to) - parse(from);
}
